<section id="faq" class="wl-section faq">
  <div class="wl-inner inner">
    <app-section-heading eyebrow="FAQ" title="Częste pytania" />
    <div class="list">
      @for (item of items; track item.q; let i = $index; let last = $last) {
        <div (click)="toggle(i)" class="item" [class.last]="last">
          <div class="q-row">
            <span class="q">{{ item.q }}</span>
            <span class="mark">{{ item.open ? '−' : '+' }}</span>
          </div>
          @if (item.open) {
            <p class="a">{{ item.a }}</p>
          }
        </div>
      }
    </div>
  </div>
</section>
